import { createWebHistory, createRouter } from "vue-router";

//const HomeContainer = { template: '<Home/>' };
const HomeContainer = { template: '<HomeDisabled/>' };
const ImprintContainer = { template: '<Imprint/>' };
const PageNotFoundContainer = { template: '<PageNotFound/>' };
const RegisterContainer = { template: '<Register/>' };
const LoginContainer = { template: '<Login/>' };
const CalculatorContainer = { template: '<CalculatorContainer/>' };
const CalculatorEditContainer = { template: '<CalculatorContainer :edit="true"/>' };
const ResultContainer = { template: '<Result/>' };
const UpdateEmailContainer = { template: '<Account><UpdateEmail/></Account>' };
const UpdatePasswordContainer = { template: '<Account><UpdatePassword/></Account>' };
const UpdateProfileContainer = { template: '<Account><UpdateProfile/></Account>' };
const ProjectsContainer = { template: '<Account><Projects/></Account>' };
const ChangelogsContainer = { template: '<Changelogs/>' };
const ForgotContainer = { template: '<Forgot/>' };
const VerifyContainer = { template: '<Verify/>' };
const ResetContainer = { template: '<Reset/>' };
const PrivacyContainer = { template: '<Privacy/>'}
const ContactContainer = { template: '<Contact/>'}
const AboutContainer = { template: '<About/>'}
const WebinarContainer = { template: '<Webinar/>'}
const TermsOfUseContainer = { template: '<TermsOfUse/>'}
const LoadingHashContainer = { template: '<LoadingHash/>'}
const EditingContainer = { template: '<Editing/>'}

const routes = [
    {
        path: "/:catchAll(.*)",
        name: "404",
        component: PageNotFoundContainer
    },
    {
        path: "/",
        name: "Home",
        component: HomeContainer,
    },
    {
        path: "/laden/:hash",
        name: "LoadingHash",
        component: LoadingHashContainer,
    },
    {
        path: "/login",
        name: "Login",
        component: LoginContainer,
        meta: { onlyGuest: true,  disabled: true, }
    },
    {
        path: "/forgot",
        name: "Forgot",
        component: ForgotContainer,
        meta: { onlyGuest: true,  disabled: true, }
    },
    {
        path: "/register",
        name: "Register",
        component: RegisterContainer,
        meta: { onlyGuest: true,  disabled: true, }
    },
    {
        path: "/reset/:token",
        name: "Reset",
        component: ResetContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/imprint",
        name: "Imprint",
        component: ImprintContainer
    },
    {
        path: "/contact",
        name: "Contact",
        component: ContactContainer
    },
    {
        path: "/about",
        name: "About",
        component: AboutContainer
    },
    {
        path: "/redaktion",
        name: "Redaktion",
        component: EditingContainer
    },
    {
        path: "/privacy",
        name: "Privacy",
        component: PrivacyContainer
    },
    {
        path: "/terms-of-use",
        name: "TermsOfUse",
        component: TermsOfUseContainer
    },
    {
        path: "/webinar",
        name: "Webinar",
        component: WebinarContainer
    },
    {
        path: "/form/edit/:id/:version",
        name: "CalculatorEdit",
        component: CalculatorEditContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/form",
        name: "Calculator",
        component: CalculatorContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/form/result/:id",
        name: "ResultContainer",
        component: ResultContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/account",
        name: "UpdateProfile",
        component: UpdateProfileContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/projects",
        name: "Projects",
        component: ProjectsContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/changelogs",
        name: "Changelogs",
        component: ChangelogsContainer
    },
    {
        path: "/edit-password",
        name: "UpdatePassword",
        component: UpdatePasswordContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/edit-email",
        name: "UpdateEmail",
        component: UpdateEmailContainer,
        meta: { requiresAuth: true,  disabled: true, }
    },
    {
        path: "/verify",
        name: "Verify",
        meta: { disabled: true },
        component: VerifyContainer,
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {

    const isLoggedIn = localStorage.getItem('token') || '';
    const verified = localStorage.getItem('verified');

    if (to.matched.some(record => record.meta.disabled))  {
        next({
            path: '/'
        })
    } else if (to.matched.some(record => record.meta.requiresAuth)) {

        if (isLoggedIn != '' && verified == 'no') {

            next({
                path: '/verify'
            })
        } else if (isLoggedIn == '') {

            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.onlyGuest)) {
        if (isLoggedIn != '') {
            next({
                path: '/form'
            })
        } else {
            next()
        }

    } else {
        next() // make sure to always call next()!
    }


})


export default router;
